import React, { FC } from 'react';
import { Box, Image } from '@chakra-ui/react';
import VideoGridItemOverlay from 'ts/common/components/gallery/VideoGridItemOverlay';

// Smaller than the grid's default 60: the cart thumbnail is only 98px tall.
const PLAY_BUTTON_SIZE = 40;

export interface ICartItemMediaThumbnail {
    alt?: string;
    /** Duration in seconds, for the badge. Slideshows store milliseconds, so they convert first. */
    duration?: number;
    isBlackAndWhite?: boolean;
    photoUrl: string;
}

/**
 * Cart line-item thumbnail for video/slideshow: a photo with a play-button overlay, instead of
 * the computer-monitor mockup DigitalRender uses for other digital downloads.
 */
const CartItemMediaThumbnail: FC<ICartItemMediaThumbnail> = ({
    alt = '',
    duration,
    isBlackAndWhite = false,
    photoUrl
}) => {
    return (
        <Box position="relative" width="100%" height="100%" overflow="hidden">
            <Image
                alt={alt}
                src={photoUrl}
                filter={isBlackAndWhite ? 'grayscale(1)' : undefined}
                width="100%"
                height="100%"
                objectFit="cover"
                draggable={false}
            />
            <VideoGridItemOverlay duration={duration} size={PLAY_BUTTON_SIZE} />
        </Box>
    );
};

export default CartItemMediaThumbnail;
